import { Outlet, createRootRoute, redirect } from '@tanstack/react-router'

/** Prefixo legado: o route group `(dashboard)` do Next nunca apareceu na URL. */
const LEGACY_PREFIX = '/dashboard/'

/**
 * Rota raiz — equivalente ao `src/app/layout.tsx` do Next.js.
 *
 * O `<html>`/`<body>` e as metatags saíram daqui e foram para `index.html`,
 * que agora é o documento real servido pelo Vite.
 */
export const rootRoute = createRootRoute({
  /**
   * Redireciona `/dashboard/<rota>` → `/<rota>`, para links externos e atalhos
   * salvos que prefixavam com o nome do route group. Era o que o
   * `src/middleware.ts` fazia via rewrite.
   *
   * ⚠️ Isto mora no `beforeLoad` da raiz, e NÃO em uma rota splat
   * `/dashboard/$`, porque o splat do TanStack Router casa também com o
   * caminho vazio: `/dashboard` batia em `/dashboard/$` com `_splat === ''`
   * — e, por ranquear acima da rota estática `/dashboard`, engolia a página do
   * dashboard inteira. O redirect resultante (`/dashboard` → `/` → `/dashboard`)
   * era um laço infinito que derrubava o app já no primeiro load, com
   * "Too many redirects" na tela.
   *
   * O `beforeLoad` da raiz roda em toda navegação e não disputa matching com
   * ninguém, então não tem como sombrear uma rota. E o laço não se repete: o
   * destino nunca começa com `/dashboard/`.
   */
  beforeLoad: ({ location }) => {
    if (location.pathname.startsWith(LEGACY_PREFIX)) {
      // `href` é pathname + search + hash, então a query sobrevive ao corte.
      // '/dashboard'.length === 10 — `/dashboard/` sozinho vira `/`.
      throw redirect({ href: location.href.slice(10), replace: true })
    }
  },
  component: () => <Outlet />,
})
